import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OffersRoutingModule } from './offers-routing.module';
import { SummaryComponent } from '../components/summary/summary.component';
import { OfferCardComponent } from '../components/offer-card/offer-card.component';
import { MOLayoutModule } from '../../../mo-layout/mo-layout.module';
import { MOFormsModule } from '../../../mo-forms/mo-forms.module';
import { OffersPage } from './offers.page';

@NgModule({
  declarations: [OffersPage, OfferCardComponent, SummaryComponent],
  imports: [CommonModule, OffersRoutingModule, MOLayoutModule, MOFormsModule],
})
export class OffersModule {}
